module.exports = __webpack_public_path__ + "static/img/drop-down_box_background.25ae9ded.png";